import { atom } from 'jotai';

export type TariffAtom = {
  tariffOperator: string;
  tariffName: string;
  subscribedPower: number;
  kickBackFactor: number;
  pricePerMonth: number;
  pricePerYear: number;
  subscriptionPricePerMonth: number;
  pricePerKWH: number;
  savedWithV2G: number;
} | null;

export const tariffInitialValue: TariffAtom = null;

export const tariffAtom = atom<TariffAtom>(tariffInitialValue);
